import { createSlice } from '@reduxjs/toolkit';

const AdminUserSlice = createSlice({
  name: 'AdminUserSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    isLogoutLoading: false,
    isConnectedAccountsLoading: false,
    isRemoveConnectedAccountLoading: false,
    adminUserListData: [],
    activityLogData: [],
    connectedAccountsList: [],
    isError: null,
    viewAdminUserDetails: null,
  },
  reducers: {
    /////// Admin User list start //////

    requestAdminUserList: (state) => {
      return { ...state, isLoading: true };
    },
    responseAdminUserList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        adminUserListData: action?.payload?.data,
      };
    },
    failureAdminUserList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Admin User Add-Edit //////
    requestAdminUserAdd: (state) => {
      return { ...state, isLoading: true };
    },
    responseAdminUserAdd: (state) => {
      return { ...state, isLoading: false };
    },
    failureAdminUserAdd: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Admin User View /////////
    requestAdminUserView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseAdminUserView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewAdminUserDetails: action.payload,
      };
    },
    failureAdminUserView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ////// Admin User Delete ////
    requestAdminUserDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responseAdminUserDelete: (state) => {
      return { ...state, isLoading: false };
    },
    failureAdminUserDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Activity Log List //////
    requestActivityLogList: (state) => {
      return { ...state, isLoading: true };
    },
    responseActivityLogList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        activityLogData: action?.payload?.data,
      };
    },
    failureActivityLogList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Admin Logout //////
    requestAdminLogout: (state) => {
      return { ...state, isLogoutLoading: true };
    },
    responseAdminLogout: (state) => {
      return { ...state, isLogoutLoading: false };
    },
    failureAdminLogout: (state, action) => {
      return { ...state, isLogoutLoading: false, isError: action?.payload };
    },

    /////// Stripe Connected Accounts //////
    requestConnectedAccounts: (state) => {
      return { ...state, isConnectedAccountsLoading: true };
    },
    responseConnectedAccounts: (state, action) => {
      return {
        ...state,
        isConnectedAccountsLoading: false,
        connectedAccountsList: action?.payload?.data || [],
      };
    },
    failureConnectedAccounts: (state, action) => {
      return {
        ...state,
        isConnectedAccountsLoading: false,
        isError: action?.payload,
      };
    },

    /////// Remove Connected Account //////
    requestRemoveConnectedAccount: (state) => {
      return { ...state, isRemoveConnectedAccountLoading: true };
    },
    responseRemoveConnectedAccount: (state) => {
      return { ...state, isRemoveConnectedAccountLoading: false };
    },
    failureRemoveConnectedAccount: (state, action) => {
      return {
        ...state,
        isRemoveConnectedAccountLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  failureAdminUserAdd,
  failureAdminUserDelete,
  failureAdminUserList,
  failureAdminUserView,
  requestAdminUserAdd,
  requestAdminUserDelete,
  requestAdminUserList,
  requestAdminUserView,
  responseAdminUserAdd,
  responseAdminUserDelete,
  responseAdminUserList,
  responseAdminUserView,
  requestActivityLogList,
  responseActivityLogList,
  failureActivityLogList,
  requestAdminLogout,
  responseAdminLogout,
  failureAdminLogout,
  requestConnectedAccounts,
  responseConnectedAccounts,
  failureConnectedAccounts,
  requestRemoveConnectedAccount,
  responseRemoveConnectedAccount,
  failureRemoveConnectedAccount,
} = AdminUserSlice.actions;
export default AdminUserSlice.reducer;
